import { APP_NAME } from '../constant'

const vi = {
  'i0001': 'Đoạn text tiếng việt',
  'i0002': 'Trang chủ',
  'i0003': 'Về chúng tôi',
  'i0004': 'Thử nghiệm',
}
export default vi






















